<template>

  <section>
    <div class="top_recognition">
      <div>
        <img src="../assets/appointment.jpg" style="width: 100%;height: 180px;margin-bottom: 10px;" />
      </div>
      <div class="recognition">
        <div style="font-size: 20px;color: #2754BB;margin: 10px 0;">买机票送车票预约购票</div>
      </div>
    </div>

    <div class="infomation" style="display: flex;">
      <div class="goCityDiv" style="margin-left: -2%;margin-bottom: 10px;">
        <span style="color: red;">*</span>出发地:
        <input style="width: 62%;" class="goCity" @click='chooseDepCity' :value="goCity" type="text" placeholder="请选择出发地" />
      </div>
      <div class="arrCityDiv" style="margin-left: -10%;margin-bottom: 10px;">
        <span style="color: red;">*</span>目的地:
        <input style="width: 62%;" class="arrCity" @click='chooseArrCity' :value="backCity" type="text" placeholder="请选择目的地" />
      </div>
      <div style="margin-left: -2%;margin-bottom: 10px;">
        <span style="color: red;">*</span>姓名 :
        <input :value="name" class="name" v-on:input="inputname" type="text" placeholder="输入姓名" />
      </div>
      <div style="margin-left: -10%;margin-bottom: 10px;">
        <span style="color: red;">*</span>电话 :
        <input :value="phone" class="phone" v-on:input="inputphone" type="text" placeholder="输入联系电话" />
      </div>
      <div style="width:45%;display:flex;justify-content:flex-start;margin-left:3%;margin-bottom: 10px;" @click="chooseGoDete">
        去程：
        <div style="width:71%;border-bottom: 1px solid #333333;margin-left: 2%;">{{ goDete }}</div>
      </div>
      <div style="width: 50%;display: flex;justify-content: flex-start;margin-bottom: 10px;" @click="chooseBackDete">
        返程：
        <div style="width:64%;border-bottom: 1px solid #333333;margin-left: 2%;">{{ backDete }}</div>
      </div>
      <div style="width: 100%;margin-left: 3%;margin-bottom: 10px;">
        出行人数 :
        <input :value="people" style="width:74%;" class="people" v-on:input="inputpeople" type="number" placeholder="出行人数" />
      </div>
      <div style="width: 100%;margin-left: 3%;margin-bottom: 10px;">
        您的备注 :
        <input :value="remark" style="width:74%;" class="remark" v-on:input="inputReamrk" type="text" placeholder="输入您的备注信息" />
      </div>
    </div>

    <button class="appointment" v-on:click="appointment()" style="display: block;">预约</button>

    <div style="width: 96%;margin: 0 2%;text-align: center;">中山候机楼丨0760-88880777 / 18029902235</div>

  </section>
</template>

<script>
  import baseTool from '../utils/baseFunction';
  import flightApi from '../request/flightApi';
  import addressApi from '../request/addressApi';
  import appointApi from '../request/appointApi';
  import shop from '../request/scopeApi.js';
  import axios from 'axios';
  import {
    mapState
  } from "vuex";
  export default {
    name: 'shopAppointment',
    data() {
      return {
        goCity: '',
        backCity: '',
        name: '',
        phone: '',
        people: '',
        remark: '',

        goDete: '选择去程日期',
        backDete: '选择返程日期',

      };
    },
    components: {},
    mounted() {
      var that = this;
      document.querySelector('body').setAttribute('style', 'background-color:#EAF3FA;overflow-y: scroll;height: auto;');
      // 记录查找记录
      flightApi.saveSearchFlightRecord(this.$store.state.user.OpenId, baseTool.formatterDate(new Date()),'买机票送车票预约').then(sucRes => {});
      this.$store.commit('flight/setFlightQueryCondition', {
        depCity: '',
        depCityPortCode: '',
        arrCity: '',
        arrCityPortCode: ''
      });
      this.getUserAddress();
      if (JSON.stringify(this.$route.params) == '{}') {} else {
        // console.log(this.$route.params.shoporderid)
        appointApi.getorderDetail(this.$store.state.user.OpenId,this.$route.params.shoporderid).then(success => {
          this.isable = true;

          this.goCity = success.data.ProductName.substring(0,2),
          this.backCity =  success.data.ProductName.substring(3,5),
          this.name =  success.data.RealName,
          this.phone =  success.data.Mobile,
          this.people =  success.data.Remarks.split(":")[1].replace('人备注',''),
          this.remark =  success.data.Remarks.split(":")[2],


          console.log(success.data.BookingStartDate);
          if(success.data.BookingStartDate == null){
            that.goDete = ""
          }
          else{
            that.goDete =  success.data.BookingStartDate.split("T")[0];
          }

          if(success.data.BookingEndDate == null){
            this.backDete = ""
          }
          else{
            this.backDete =  success.data.BookingEndDate.split("T")[0];
          }

        }).catch(fil=>{});
      }
    },
    activated() {
      this.goCity = this.depCity
      this.backCity = this.arrCity
    },
    methods: {
      getUserAddress() {
        // 获取地址列表
        addressApi.getAddressList(this.$store.state.user.OpenId, '').then(sucRes => {
          if (sucRes.success && sucRes.data.length > 0) {
            sucRes.data.forEach(item => {
              if (item.IsDefault == true) {
                this.name = item.Contact;
                this.phone = item.Mobile;
              }
            });
          }
        });
      },
      chooseDepCity() {
        this.$router.push({
          name: "City",
          params: {
            mode: "dep",
          },
        });
      },
      chooseArrCity() {
        this.$router.push({
          name: "City",
          params: {
            mode: "arr",
          },
        });
      },
      changeShow(show) {
        this.show = !show;
      },
      inputname(e) {
        this.name = e.target.value;
      },
      inputphone(e) {
        this.phone = e.target.value;
      },
      inputpeople(e) {
        this.people = e.target.value;
      },
      inputReamrk(e) {
        this.remark = e.target.value;
      },
      chooseGoDete() {
        let that = this;
        this.$weui.datePicker({
          start: new Date(), // 从今天开始
          end: baseTool.addDate(new Date(), 60),
          onConfirm: result => {
            let tmpDate =
              result[0].value +
              '-' +
              (result[1].value < 10 ? '0' + result[1].value : result[1].value) +
              '-' +
              (result[2].value < 10 ? '0' + result[2].value : result[2].value);
            that.goDete = tmpDate;
          }
        });
      },
      chooseBackDete() {
        let that = this;
        this.$weui.datePicker({
          start: new Date(), // 从今天开始
          end: baseTool.addDate(new Date(), 60),
          onConfirm: result => {
            let tmpDate =
              result[0].value +
              '-' +
              (result[1].value < 10 ? '0' + result[1].value : result[1].value) +
              '-' +
              (result[2].value < 10 ? '0' + result[2].value : result[2].value);
            that.backDete = tmpDate;
          }
        });
      },
      appointment() {
        var that = this;
        if (this.goCity == '' || this.arrCity == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '出发地或目的地不能为空'
          });
          return;
        }
        if (this.name == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '姓名不能为空'
          });
          return;
        } else if (this.phone == '') {
          this.$Modal.warning({
            title: '操作提示',
            content: '电话号码不能为空'
          });
          return;
        } else if (this.goDete > this.backDete) {
          this.$Modal.warning({
            title: '操作提示',
            content: '去程日期不得大于返程日期'
          });
          return;
        } else if (this.phone.length < 8 || this.phone.length > 11 || this.phone.length == 9 || this.phone.length == 10) {
          this.$Modal.warning({
            title: '操作提示',
            content: '电话号码长度不正确'
          });
          return;
        }
        // } else if (this.people < 3 && (type == 0)) {
        //   alert('出行人数必须3人起');
        //   return;
        // }
        if (this.goDete == '选择去程日期') {
          this.goDete = 'null';
        }
        if (this.backDete == '选择返程日期') {
          this.backDete = 'null';
        }
        if (this.people == '') {
          this.people = '0';
        }
        console.log(this.$store.state.user.OpenId, this.name, this.phone, this.people, this.remark, this.goDete, this.backDete,
          this.goCity + '-' + this.arrCity);
        flightApi.appointmentFlight(
            this.$store.state.user.OpenId,
            this.goCity + '-' + this.arrCity,
            this.name,
            this.phone,
            '买机票送车票预约:' + '出行人数:' + this.people + '人' + '备注:' + this.remark,
            this.goDete,
            this.backDete
          )
          .then(sucRes => {
            that.goCity = '',
              that.backCity = '',
              that.name = '',
              that.phone = '',
              that.people = '',
              that.remark = '',
              that.goDete = '选择去程日期'
            that.backDete = '选择返程日期'
            if (sucRes.success == true) {
              this.$Modal.success({
                title: '恭喜你!',
                content: sucRes.message
              });
            } else {
              this.$Modal.error({
                title: '很遗憾!',
                content: sucRes.message
              });
            }
          });
      },
    },
    computed: mapState({
      depCity: (state) => state.flight.depCity,
      depCityPortCode: (state) => state.flight.depCityPortCode,
      arrCity: (state) => state.flight.arrCity,
      arrCityPortCode: (state) => state.flight.arrCityPortCode,
    }),
  };
</script>

<style>
  p {
    margin: 0;
    margin-left: 5%;
    margin-right: 5%;
    word-wrap: normal;
    white-space: pre-line;
    word-break: break-all;
  }

  /* common */
  .infomation {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
  }

  .infomation div {
    display: flex;
    line-height: 35px;
    /* margin-left: 2%; */
    /* margin-right: 5%; */
    width: 45%;
  }

  .infomation input {
    border: none;
    background: none;
    box-shadow: none;
    border-bottom: 1px solid #333333;
    /* width: 75%; */
    width: 70%;
    padding: 0;
    margin: 0 0 0 5px;
  }

  .infomation {
    font-size: 13px !important;
    color: black !important;
  }

  /*  .goCity,
  .arrCity,
  .godate,
  .backdate,
  .name,
  .people,
  .phone,
  .remark {
    font-size: 30px;
  }
  .goCity input,
  .arrCity input,
  .godate input,
  .backdate input,
  .name input,
  .people input,
  .phone input,
  .remark input {
    font-size: 16px;
  } */

  .appointment {
    width: 94%;
    margin: 10px 3% 10px 3%;
    background: #2754bb;
    color: white;
    height: 40px;
    font-size: 18px;
    border: 0;
    border-radius: 10px;
    line-height: 10px;
    /* margin-bottom: 10px; */
  }

  input::-webkit-input-placeholder {
    color: #515A6E;
  }

  input::-moz-input-placeholder {
    color: #515A6E;
  }

  input::-ms-input-placeholder {
    color: #515A6E;
  }

  .top_recognition {
    /* margin: 0 0 10px 0; */
  }

  .recognition {
    text-align: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/shopAppointment.vue